import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { useEditPaymentType } from '../api/editPaymentType';
import { Fields } from '../hooks/usePaymentTypeForm';

import { PaymentTypeForm } from './PaymentTypeForm';

type EditModalProps = {
  paymentTypeId: string;
  initialValues: Fields;
};

export const EditModal = NiceModal.create(({ initialValues, paymentTypeId }: EditModalProps) => {
  const modal = useModal();

  const { mutate, isLoading } = useEditPaymentType({
    onSuccess: modal.hide,
  });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title="Редактирование типа платежа"
    >
      <PaymentTypeForm
        isLoading={isLoading}
        onSubmit={(params) => mutate({ ...params, _id: paymentTypeId })}
        initialValues={initialValues}
      />
    </Modal>
  );
});
